import { defineComponent as _defineComponent } from 'vue'
import HtmlTemplate from '@/grpc-api/model/html-template';
import {
  ref, computed, onMounted, onBeforeUnmount, getCurrentInstance,
} from 'vue';
import { loadStoreModule, tryUnloadStoreModule, unloadStoreModule } from '@/services/module-loader';
import MarketingCampaignManagerStore from '@/store/marketing-campaign-manager-store';
import { performDispatchAction, performSaveAction } from '@/services/vue-utils';
import store from '@/store/store';
import { cloneModel } from '@/model/model-utils';
import nameWithCopyText from '@/util/copy-name';
import i18n from '@/plugins/i18n';
import InputDialog from '@/components/dialogs/InputDialog.vue';
import showConfirmationDialog from '@/components/dialogs/confirmation-dialog';
import TemplateGridView from './TemplateGridView.vue';
import NewsletterTemplateEditorDialog from './NewsletterTemplateEditorDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsletterTemplateLibrary',
  setup(__props) {

const isNewsletterFeatureAllowed = computed<boolean>(() => store.getters.isNewsletterFeatureAllowed);

const upgradeDialog = ref(false);

const templates = computed(() => store.getters.marketingCampaignManagerHtmlTemplates as HtmlTemplate[]);

const editedTemplate = ref(undefined as undefined | HtmlTemplate);

// rename dialog
const renameTemplateAction = ref(undefined as undefined | ((name: string) => void));

// template actions
const editTemplate = (t: HtmlTemplate) => {
  editedTemplate.value = t;
};

const saveTemplate = async (template: HtmlTemplate) => {
  const htmlTemplate = cloneModel(template);
  let action = 'marketingCampaignManagerUpdateHtmlTemplate';

  if (template.isDefault) {
    htmlTemplate.name = nameWithCopyText(template.name, i18n.t('label.copy_of') as string);
    action = 'marketingCampaignManagerCreateHtmlTemplate';
  }

  const ok = await performSaveAction(
    undefined,
    async () => store.dispatch(action, { htmlTemplate }),
  );

  if (ok) {
    editedTemplate.value = undefined;
  }
};

const duplicateTemplate = async (template: HtmlTemplate) => {
  const htmlTemplate = cloneModel(template);
  htmlTemplate.name = nameWithCopyText(template.name, i18n.t('label.copy_of') as string);

  const ok = await performSaveAction(
    undefined,
    async () => store.dispatch('marketingCampaignManagerCreateHtmlTemplate', { htmlTemplate }),
  );
};

const deleteTemplate = async (template: HtmlTemplate) => {
  const action = async () => {
    const ok = await performSaveAction(
      undefined,
      async () => store.dispatch('marketingCampaignManagerDeleteHtmlTemplate', { htmlTemplate: template }),
      { hideSuccess: true },
    );
  };

  showConfirmationDialog(
    i18n.t('title.newsletter'),
    i18n.tc('message.confirm_delete_template'),
    { action },
    {},
  );
};

const currentTemplateName = ref('');
const renameTemplate = async (template: HtmlTemplate) => {
  currentTemplateName.value = template.name;
  renameTemplateAction.value = async (name: string) => {
    renameTemplateAction.value = undefined;
    const htmlTemplate = cloneModel(template);
    htmlTemplate.name = name;
    saveTemplate(htmlTemplate);
  };
};

// load campaign manager
const load = async () => {
  if (store.getters.isMarketingCampaignManagerLoaded) return;
  await performDispatchAction('loadMarketingCampaignManager', {});
};

const reset = async () => {
  store.dispatch('resetMarketingCampaignManager');
  tryUnloadStoreModule('serviceManager', async () => store.dispatch('resetServiceManager'));
};

onMounted(() => {
  loadStoreModule(
    getCurrentInstance()?.proxy!,
    'marketingCampaignManager',
    MarketingCampaignManagerStore,
    async () => { load(); },
  );
});

onBeforeUnmount(() => {
  unloadStoreModule(getCurrentInstance()?.proxy!, 'marketingCampaignManager', async () => { reset(); });
});


return { __sfc: true,isNewsletterFeatureAllowed, upgradeDialog, templates, editedTemplate, renameTemplateAction, editTemplate, saveTemplate, duplicateTemplate, deleteTemplate, currentTemplateName, renameTemplate, load, reset, InputDialog, TemplateGridView, NewsletterTemplateEditorDialog }
}

})